var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TooltipButton',{attrs:{"icon":_vm.Icon,"color":_vm.color,"tooltip":_vm.tooltip},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }